export default "__VITE_ASSET__BX$fecaG__"